var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("b-form-tags", {
        attrs: {
          value: _vm.value,
          disabled: _vm.disabled,
          placeholder: _vm.placeholder,
          state:
            _vm.required && (!_vm.value || _vm.value.length === 0)
              ? false
              : null,
          separator: ",",
          "tag-variant": "info",
          "remove-on-delete": "",
          "add-button-text": "Tambah",
          "duplicate-tag-text": "Jurusan sudah ada",
        },
        on: { input: _vm.onInput },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "text-muted" }, [
        _vm._v("Pisahkan dengan Enter atau koma."),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }